import { EssentialsActions } from './essentials.types';

const initialState = {
  postEssentialPlanState: { status: 'idle', error: '' } as BaseState,
  planSelectCount: 0
};

const essentialsReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: EssentialsActions
): typeof initialState => {
  switch (action.type) {
    case 'POST_ESSENTIAL_PLAN_REQUEST':
      return {
        ...state,
        postEssentialPlanState: {
          ...state.postEssentialPlanState,
          error: '',
          status: 'pending'
        }
      };

    case 'POST_ESSENTIAL_PLAN_SUCCESS':
      return {
        ...state,
        postEssentialPlanState: {
          ...state.postEssentialPlanState,
          status: 'idle'
        }
      };

    case 'POST_ESSENTIAL_PLAN_FAILURE':
      return {
        ...state,
        postEssentialPlanState: {
          ...state.postEssentialPlanState,
          status: 'rejected',
          error: action.payload
        }
      };

    case 'INCREMENT_PLAN_SELECT_COUNT':
      return {
        ...state,
        planSelectCount: state.planSelectCount + 1
      };

    case 'RESET_PLAN_SELECT_COUNT':
      return {
        ...state,
        planSelectCount: 0
      };

    default:
      return state;
  }
};

export default essentialsReducer;
